module.exports = __webpack_public_path__ + "static/maiawork-e125d18d8aae8cab64ad382cdeac9716.png";